








import { Component, Vue } from 'vue-property-decorator';
import DotLoader from 'vue-spinner/src/DotLoader.vue';
import { mapState } from 'vuex';

@Component ({
	components: { DotLoader },
	computed: mapState (['loading'])
})
export default class Loading extends Vue
{
}

